module.exports = ".fullpage {\n  height: calc(100vh - 105px) !important; }\n\n.modalpage {\n  min-height: 60vh !important;\n  max-height: 60vh !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/file-manager/file-manager.component.scss
// module id = ./src/app/components/file-manager/file-manager.component.scss
// module chunks = main